import { DialogueData } from "@/components/Dialog"
import { create } from "zustand"

export interface shareState {
    chessBoardImg: string
    chessResultImg: string
    text: string
    winner: "black" | "white" | null
    dialogueData: DialogueData[]
    setShareData: (
        chessBoardImg: string,
        chessResultImg: string,
        text?: string,
        dialogueData?: DialogueData[], //用于展示对话
        winner?: "black" | "white" | null
    ) => void
}

export const useShareStore = create<shareState>((set) => ({
    chessBoardImg: "",
    chessResultImg: "",
    text: "",
    winner: null,
    dialogueData: [],

    setShareData: (
        chessBoardImg,
        chessResultImg,
        text = "",
        dialogueData = [],
        winner = null
    ) => set({ chessBoardImg, chessResultImg, text, dialogueData, winner }),
}))
